import { Stack, Text } from "@mantine/core";

/**
 * One uppercase-label-over-value stat, as rendered in a DetailDialog's header
 * strip to restate the summary row the dialog was opened from.
 */
const HeaderStat = ({ label, value }: { label: string; value: string }) => (
  <Stack gap={0}>
    <Text size="xs" c="dimmed" tt="uppercase" style={{ letterSpacing: 0.4 }}>
      {label}
    </Text>
    <Text size="md" fw={600}>
      {value}
    </Text>
  </Stack>
);

export default HeaderStat;
